import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

export function contractNumberFromCostAgreementId(
  line: AssignmentLine,
  costAgreementId: string,
): number | null {
  const option = line.buyContractPriceOptions.find(
    (row) => row.costAgreementId === costAgreementId,
  );
  return option?.contractNumber ?? null;
}

export function costAgreementIdForContractNumber(
  line: AssignmentLine,
  contractNumber: number,
): string | null {
  const option = line.buyContractPriceOptions.find(
    (row) => row.contractNumber === contractNumber,
  );
  return option?.costAgreementId ?? null;
}
